import cn from 'classnames';

import { Download } from '@webapp/account/src/components/download';
import { TaskWaiting } from '@webapp/account/src/components/task-waiting';
import type { SubtaskStatus } from '@webapp/account/src/resources/tasks/task';

import { Button } from '@webapp/common/components/button';
import { CssUiComponent } from '@webapp/common/components/survey-custom';

import css from './footer.css';

export const Footer: FC<{
    loading: boolean;
    complete: boolean;
    link?: string;
    size?: number;
    disabled: boolean;
    onClick: () => void;
    progress: number;
    taskStatus: SubtaskStatus;
    onDownload: () => void;
}> = ({ complete, disabled, link, loading, onClick, onDownload, progress, size, taskStatus }) => (
    <div className={cn(css.footer, CssUiComponent.NO_PRINT)}>
        <div className={css.action}>
            {!loading && !complete && (
                <Button fluid className={css.btn} color='blue' disabled={disabled} loading={false} onClick={onClick}>
                    Сформировать отчет
                </Button>
            )}
            {loading && <TaskWaiting progressPercent={progress} status={taskStatus} />}
            {complete && <Download link={link} size={size} onDownload={onDownload} />}
        </div>
    </div>
);
